import { FunctionComponent } from 'react'
import { IconName } from '~/components/Icon'
import { SITE_PRODUCT_LABEL, SiteProduct } from './siteProduct'

/**
 * One icon per product, reusing icons the app already associates with each: the Analytics section's own
 * menu icon, the `ad_stack` glyph aliased `AdmIcon` for One, and the server for Node's server-side auctions.
 *
 * The Product cell no longer draws these — three names this short read faster on their own than with a glyph
 * repeating them. It stays exported for the places that have room for a mark and not for a word: the
 * bidder rule flyout's "Used by" table gives its product column an icon and a tooltip, not a label.
 */
export const SITE_PRODUCT_ICON: Record<SiteProduct, IconName> = {
  analytics: 'chart_bar',
  adm: 'ad_stack',
  pbs: 'server',
}

/**
 * How a media's product reads in a table cell, for the media list and the archived one both.
 *
 * It lives here rather than in either page because the two lists showed the same value two different
 * ways — a chip on one, a chip on the other — and the point of one component is that they cannot drift
 * apart again.
 */
export const SiteProductIndicator: FunctionComponent<{ product: SiteProduct }> = ({ product }) => <span>{SITE_PRODUCT_LABEL[product]}</span>
